module.exports = __webpack_public_path__ + "dba60030e11d5df64478de19c4cc496f.png";